var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionLikeFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33293 14.8854C6.58813 13.8381 4.96497 12.6056 3.4925 11.2098C2.45729 10.2046 1.66919 8.97917 1.18858 7.62736C0.323697 5.00502 1.33394 2.00295 4.16115 1.1145C5.64702 0.647993 7.26982 1.69856 8.52189 2.61493C9.77445 1.69968 11.3967 0.649203 12.8826 1.1145C15.7099 2.00295 16.7274 5.00502 15.8625 7.62736C15.3819 8.97917 14.5938 10.2046 13.5586 11.2098C12.0861 12.6056 10.4629 13.8381 8.71813 14.8854L8.52916 15L8.33293 14.8854Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionLikeFilled);
export default __webpack_public_path__ + "static/media/action-like-filled.b56ab60f0cb57297caf772c3c0e7aacf.svg";
export { ForwardRef as ReactComponent };